import React, { useEffect } from 'react';
import Routes from './routes/Routes';
import { useDispatch } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

// setup fake backend

// Themes
// default
import './assets/scss/theme.scss';
import { GlobalDebug } from './helpers/remove-consoles';
import { getLoggedInUser, isUserAuthenticated } from './helpers/authUtils';
import { logoutUser } from './redux/actions';

// dark
// import './assets/scss/theme-dark.scss';

// rtl
// import './assets/scss/theme-rtl.scss';

/**
 * Main app component
 */
const App = () => {
    const dispatch = useDispatch();
    
    useEffect(() => {
        (process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENV === 'STAGING') && GlobalDebug(false);

        checkSession();

        // Check if token is valid every 5min
        setInterval(checkSession, 300000);
    }, []);

    const checkSession = () =>  {
        const user = getLoggedInUser();
        if(user?.token && !isUserAuthenticated()) {
            dispatch(logoutUser());
        }
    };

    return (
        <BrowserRouter>
            <Routes />
        </BrowserRouter>
    );
};

export default App;
